export const baseEndpoint = process.env.REACT_APP_BASE_ENDPOINT != null ? process.env.REACT_APP_BASE_ENDPOINT : "http://localhost:3010";
